import React, { useState, useEffect } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { Modal, Button } from 'react-bootstrap';
import '@fullcalendar/core/index.cjs';
import '@fullcalendar/daygrid/index.cjs';
import axios from 'axios';
import dayjs from 'dayjs';

const AttendanceCalendar = () => {
  const [events, setEvents] = useState([]);
  const [modalInfo, setModalInfo] = useState(null);
  const [calendarReady, setCalendarReady] = useState(false); // NEW

  const currentDate = new Date();
  const month = currentDate.getMonth() + 1;
  const year = currentDate.getFullYear();

  useEffect(() => {
    axios.get(`/api/student/get-student-monthly-attendance`, {
      params: { month, year }
    }).then(res => {
      const formatted = res.data.map(row => ({
        title: 'P',
        date: row.date,
        extendedProps: {
          in_time: row.in_time,
          out_time: row.out_time
        },
        classNames: ['present-attendance-event'],
      }));
      setEvents(formatted);
      setCalendarReady(true);
    });
  }, []);

  const handleDayCellMount = (info) => {
    const isPresent = events.find(event =>
      dayjs(event.date).format('YYYY-MM-DD') === dayjs(info.date).format('YYYY-MM-DD')
    );
    const isSunday = info.date.getDay() === 0;
    
    if (isPresent) {
      info.el.classList.add('present-days');
    }

    if (isSunday) {
      info.el.classList.add('sunday-day');
    }
  };

  const handleDateClick = (arg) => {
    const found = events.find(e => e.date === arg.dateStr);
    if (found) {
      setModalInfo({
        date: found.date,
        in: found.extendedProps.in_time,
        out: found.extendedProps.out_time
      });
    }
  };

  return (
    <>
      <div id='wrap'>
        {calendarReady && (
          <FullCalendar
            plugins={[dayGridPlugin, interactionPlugin]}
            initialView="dayGridMonth"
            events={events}
            dateClick={handleDateClick}
            height="auto"
            dayCellDidMount={handleDayCellMount}
            titleFormat={{ year: 'numeric', month: 'short' }}
          />
        )}
        <Modal show={!!modalInfo} onHide={() => setModalInfo(null)}>
          <Modal.Header closeButton>
            <Modal.Title>Attendance Detail</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p><strong>Date:</strong> {modalInfo?.date}</p>
            <p><strong>In Time:</strong> {dayjs(modalInfo?.in, 'HH:mm:ss').format('h:mm A')}</p>
            <p><strong>Out Time:</strong> {modalInfo?.out ? dayjs(modalInfo?.out, 'HH:mm:ss').format('h:mm A') : '-'}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setModalInfo(null)}>Close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default AttendanceCalendar;